import * as _ from 'underscore';
import { Messages } from '../../codegen/Localize';
import { IEnableAccelerationAction } from '../../ts/ServerApi/types/actionNames';
import { IWorkbookInfo } from '../../ts/models/IWorkbookInfo';
import { Action } from 'redux';
import { EnableWorkbookAcceleration } from '../../app/actions/AppActionTypes';
import { IEntityAction, EntityActionNames } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { WorkbookAccelerationActions } from './WorkbookAccelerationActions';

export const EnableWorkbookAccelerationEntityAction: IEntityAction<IWorkbookInfo, IEnableAccelerationAction> = {
  name: EntityActionNames.AccelerateWorkbook,
  translateName: Messages.enableAcceleration,
  isVisible: (targetItems: IWorkbookInfo[]) => {
    return WorkbookAccelerationActions.assurePermission(targetItems);
  },
  isClickable: (availableActions: IEnableAccelerationAction, targetItems: IWorkbookInfo[]) => {
    return WorkbookAccelerationActions.assurePermission(targetItems) &&
              (targetItems.length > 1 ||
                !!(availableActions && availableActions.enableAcceleration));
  },
  createReduxAction: (targetItems: IWorkbookInfo[]) => enableWorkbookAcceleration(targetItems)
};

export interface EnableWorkbookAccelerationAction extends Action {
  selectedContent: IWorkbookInfo[];
}

export function enableWorkbookAcceleration(
  selectedContent: IWorkbookInfo[]
): EnableWorkbookAccelerationAction {
  return {
    type: EnableWorkbookAcceleration,
    selectedContent: selectedContent,
  };
}
